import { gql } from '@apollo/client';

export const DOWNLOAD_SHOPIFY_CUSTOMERS = gql`
  mutation DownloadShopifyCustomers {
    downloadShopifyCustomers {
      errors { path, message }
    }
  }
`;

export const SHOPIFY_PAYMENTS_WORKSHEET = gql`
  query ShopifyPaymentsWorksheet (
    $fromDate: ISO8601Date
    $toDate: ISO8601Date
  ) {
    shopifyPaymentsWorksheet (
      fromDate: $fromDate
      toDate: $toDate
    )
  }
`;
